import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-warning",
  "use": "tamr-icon-warning-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-warning\"><path d=\"M30.2,27.4L17.8,2.5c-1-2-2.6-2-3.6,0L1.8,27.4c-1,2,0,3.6,2.2,3.6H28C30.2,31,31.2,29.3,30.2,27.4ZM14,11h4v3l-1,7H15l-1-7V11Zm2,16a2,2,0,1,1,2-2A2,2,0,0,1,16,27Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol